import React from "react";
import TimeControl from "./Time";

export default class MultipleTimeControl extends React.PureComponent {
  state = {
    newV: null,
  };

  handleBlur() {
    const { onBlur, onChange, value } = this.props;
    const { newV } = this.state;
    if (newV) {
      const nextValue = value
        .filter((t) => t !== newV)
        .concat([newV])
        .sort();
      onChange && onChange(nextValue);
      this.setState({ newV: null });
    }
    onBlur && onBlur();
  }

  handleRemove(time) {
    const { onChange, value } = this.props;
    onChange && onChange(value.filter((t) => t !== time));
  }

  render() {
    const { onFocus, onChange, value, required, readOnlyValues = [], ...rest } = this.props;
    const { newV } = this.state;

    return (
      <div className="MultipleTimeControl">
        <a className="ui label with-icon" onClick={() => this._newControlRef.setOpen(true)}>
          <i className="icon material-icons">add</i>
          <span className="text">{I18n.t("papp.components.MultipleTimeFormControl.add_new")}</span>
        </a>
        <div style={{ display: "inline-block", visibility: "hidden", width: "0px" }}>
          <TimeControl
            {...rest}
            controlRef={(ref) => (this._newControlRef = ref)}
            value={newV}
            onFocus={onFocus}
            onBlur={this.handleBlur.bind(this)}
            onChange={(newV) => this.setState({ newV })}
            placeholder={I18n.t("papp.components.MultipleTimeFormControl.add_new")}
            required={required && value.length === 0}
            placement="topRight"
            isTimeBlocked={(v) => value.includes(v)}
          />
        </div>
        {value.map((v) => (
          <div key={v} className="ui label">
            {v}
            {!readOnlyValues.includes(v) && <i className="close icon" onClick={this.handleRemove.bind(this, v)}></i>}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/MultipleTime.jsx